module.exports = __webpack_public_path__ + "static/media/kh.907dc138.webp";